import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=8c5ec7cc"
import script from "./dictionary.vue?vue&type=script&lang=ts"
export * from "./dictionary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports